<template>
  <div>
  </div>
</template>

<script>
import { PURGE_AUTH, SET_TOKEN } from '@/store/mutations.types'
import AuthService from '@/common/auth.service'

export default {
  mounted() {
    this.$vs.loading()
    AuthService.getAccessToken()
      .then(response => {
        this.$store.commit(PURGE_AUTH)
        this.$store.commit(SET_TOKEN, response.data.access_token)
        this.$router.push({ name: 'indexPage' })
      })
      .catch(response => {
        this.$vs.notify({
          position: 'top-right',
          title: 'Не удалось авторизоваться'
        })
      })
      .finally(() => {
        this.$vs.loading.close()
      })
  }
}
</script>
<style lang="scss" scoped>
.full-page-bg-color{
  background-color: rgba(34, 145, 255, 1);
}
</style>
